







































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ElementType } from '@/models'
import { BaseTree } from '@he-tree/vue/vue2'

type ElementTypeHierarchyModel = {
  elementType: ElementType;
  children?: ElementTypeHierarchyModel[];
}

@Component({
  components: {
    BaseTree
  }
})
export default class ElementTypeHierarchy extends Vue {
  @Prop({ required: true, type: Object }) elementType: ElementType

  get elementTypes(): ElementType[] {
    return this.$store.state.elementTypes
  }

  get elementTypesParent() {
    return this.elementTypes.filter((item: ElementType) => item.childrenElementTypeAllowed?.split(',').includes(this.elementType.codeId))
  }

  get elementTypesParentNameJoin() {
    return this.elementTypesParent.map((item: ElementType) => item.name).join(', ')
  }

  get structureHierarchy() {
    return this.getChildrenAndStructure(this.elementType)
  }

  private getChildrenAndStructure(elementTypeGiven: ElementType): ElementTypeHierarchyModel[] {
    const elementTypeHierarchyArray: ElementTypeHierarchyModel[] = []

    if (elementTypeGiven.childrenElementTypeAllowed && elementTypeGiven.childrenElementTypeAllowed !== '') {
      const types = elementTypeGiven.childrenElementTypeAllowed.split(',')
      for (let i = 0; i < types.length; i++) {
        const elementTypeFinded = this.elementTypes.find((item: ElementType) => types[i] === item.codeId)
        if (elementTypeFinded) {
          const elementTypeHierarchy: ElementTypeHierarchyModel = {
            elementType: elementTypeFinded,
            children: this.getChildrenAndStructure(elementTypeFinded)
          }
          elementTypeHierarchyArray.push(elementTypeHierarchy)
        }
      }
    }

    return elementTypeHierarchyArray
  }
}
